const venues = {
    firestorePath: 'venues',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'venues',
    statePropName: 'data',
    namespaced: true, // automatically added
    fetch: {
      docLimit: 0, // 0 = no limit (library default is 50; we have 100+ venues)
    },
    state: {
    },
    getters: {
      array: state => Object.values(state.data),
      obj: state => state.data,
      byId: (state) => (id) => {
        if (id == null || id === '') return undefined
        return state.data[id] || state.data[String(id)]
      },
    },
    mutations: {},
    actions: {},
  }
  
  export default venues